/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon64Regular = forwardRef('ArrowDRadiusUpLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M23.447 7.932a1.5 1.5 0 0 1 2.106 2.136L10.639 24.77A3.822 3.822 0 0 0 9.8 26H31.5C45.583 26 57 37.417 57 51.5v2a1.5 1.5 0 0 1-3 0v-2C54 39.074 43.926 29 31.5 29H9.8c.19.448.47.867.838 1.23l14.914 14.702a1.5 1.5 0 1 1-2.106 2.136L8.533 32.366a6.833 6.833 0 0 1 0-9.732L23.447 7.932Z" })));
});
